const AssessmentProgressBar = ({
	current,
	total,
}: {
	current: number;
	total: number;
}) => {
	const percentage = (current / total) * 100;

	return (
		<div className="w-full">
			<div className="text-center text-lg font-semibold mb-2">
				Assessment Progress
			</div>
			<div className="flex justify-center items-center gap-2 mb-2">
				<div className="flex items-center gap-2 w-1/2 justify-center">
					<span className="text-sm text-gray-500 font-medium">
						{Math.round(percentage)}%
					</span>
					<div className="w-full h-2 bg-gray-200 rounded-full">
						<div
							className="h-2 bg-[#91C588] rounded-full"
							style={{ width: `${percentage}%` }}
						></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AssessmentProgressBar;
